import MockApi from './mockApi';

export const UserStatus = {
  InActive: 100,
  Active: 200,
  Blocked: 300,
  Left: 400,
};
export class Users {
  // this should be in sync with backend status

  static statusText = (status) => {
    switch (status) {
      case UserStatus.InActive:
        return 'לא פעיל';
      case UserStatus.Active:
        return 'פעיל';
      case UserStatus.Blocked:
        return 'חסום';
      case UserStatus.Left:
        return 'עזב';
      default:
        return 'לא ידוע';
    }
  };
}

export default class User {
  static GetInfo = () => {
    if (MockApi.IsActive) {
      return MockApi.GetUserInfo();
    }

    const userStr = localStorage.getItem('user');

    if (!userStr) return null;

    let userInfo;
    try {
      userInfo = JSON.parse(userStr);
    } catch (error) {
      console.error('Failed to parse user JSON:', error.message);
      return null;
    }

    if (!userInfo) return null;

    // For the logged in users that don't have screens array, we add the default screens based on the user type
    if (userInfo.info && !userInfo.info.screens) {
      if (userInfo.info.type === 1) {
        userInfo.info.screens = [
          'rtl-default',
          'companies',
          'users',
          'messaging',
          'applications',
          'forms',
          'reports',
          'integrations',
          'data-tables',
          'sales',
          'data-pipelines',
          'new-users',
          'notifications',
          'job-referrals',
        ];
      } else {
        const baseScreens = ['rtl-default', 'employees', 'transfers', 'reports-1'];
        if (userInfo.info.referralsEnabled) baseScreens.push('job-referrals');
        userInfo.info.screens = baseScreens;
      }
      localStorage.setItem('user', JSON.stringify(userInfo));
    }

    return userInfo.info;
  };
}
